var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteUserVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_1610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.75 21.25H6.25C3.48856 21.25 1.25 19.0114 1.25 16.25V6.25C1.25 3.48856 3.48856 1.25 6.25 1.25H25.75C28.5114 1.25 30.75 3.48856 30.75 6.25V16.25C30.75 19.0114 28.5114 21.25 25.75 21.25Z",
    stroke: "#662D91",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4993 10.2494L15.4993 6.49937C15.2904 6.34275 15.0311 6.25 14.75 6.25C14.0596 6.25 13.5 6.80963 13.5 7.5V15C13.5 15.6904 14.0596 16.25 14.75 16.25C15.0311 16.25 15.2905 16.1573 15.4993 16.0006L20.4993 12.2506C20.8033 12.0226 21 11.6592 21 11.25C21 10.8408 20.8033 10.4774 20.4993 10.2494Z",
    stroke: "#662D91",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 30.75C5.13071 30.75 6.25 29.6307 6.25 28.25C6.25 26.8693 5.13071 25.75 3.75 25.75C2.36929 25.75 1.25 26.8693 1.25 28.25C1.25 29.6307 2.36929 30.75 3.75 30.75Z",
    stroke: "#A58CB8",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 28.25H30.75",
    stroke: "#A58CB8",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_1610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteUserVideo);
export default __webpack_public_path__ + "static/media/invite_user_video.046f656cbe1f79a0362b6ae0f7527443.svg";
export { ForwardRef as ReactComponent };